<script>
    import { IntercomUtils } from "$/utils/IntercomUtils";
    import { fade } from "svelte/transition";

    export let show = false;

    $: if (show) {
        IntercomUtils.hide();
    } else {
        IntercomUtils.show();
    }
</script>

<div class="share-panel-wrapper" class:share-panel-wrapper--hide={!show}>
    <div class="share-panel-wrapper__slider">
        
        <!-- Don't render panel until it should be shown -->
        {#if show}

            <!-- Await for sidebar to close before removing the panel -->
            <div class="share-panel-wrapper__slot-wrapper" out:fade|local={{ delay: 500, duration: 0}}>
                <slot />
            </div>
        {/if}
    </div>
</div>

<style>
    .share-panel-wrapper {
        @apply absolute right-0 top-0 z-50 box-border flex h-full w-full max-w-full overflow-hidden border-0 border-l border-l-neutral-100 bg-gray-100 shadow-2xl transition-all duration-500 ease-in-out sm:max-w-sm;
    }

    .share-panel-wrapper__slot-wrapper {
        @apply overflow-hidden w-screen sm:w-96;
    }
    .share-panel-wrapper__slider {
        @apply absolute flex h-full w-screen sm:w-96;
    }
    .share-panel-wrapper--hide {
        @apply w-0;
    }
</style>
